import { render, staticRenderFns } from "./BotaoVoltar.vue?vue&type=template&id=31fd4934&scoped=true"
import script from "./BotaoVoltar.vue?vue&type=script&lang=js"
export * from "./BotaoVoltar.vue?vue&type=script&lang=js"
import style0 from "./BotaoVoltar.vue?vue&type=style&index=0&id=31fd4934&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fd4934",
  null
  
)

export default component.exports